import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useUserContext from 'Context/UserContext';
import PreviousButton from 'Views/Onboarding/Components/Navigator/PreviousButton';

const styles = () => ({
  root: {},
});

const PreviousButtonContainer = (
) => {
  const { setPageContentCollection } = usePageContentContext();
  const { agentResource } = useUserContext();
  const link = agentResource.relationship(fr.relationships.generatedView.name).link('related');

  return (
    <PreviousButton
      onClick={async () => {
        const previousCollection = await link.get();
        setPageContentCollection(previousCollection);
      }}
    />

  );
};

PreviousButtonContainer.defaultProps = {
};

PreviousButtonContainer.propTypes = {
};

export default withStyles(styles)(PreviousButtonContainer);
